// Routes Constants

export const ROUTES = {
  HOME: '/',
  BREAKING: '/breaking',
  NEW: '/new',
  MARKETS: '/markets',
  MARKET_DETAILS: (slug: string) => `/markets/${slug}`,
  LIVE_MARKET_DETAILS: (slug: string) => `/live-markets/${slug}`,
  CATEGORY: (slug: string) => `/${slug}`,
  POLITICS: '/politics',
  SPORTS: '/sports',
  GAME_DETAIL: (slug: string, id: string) => `/sports/${slug}/${id}`,
  FINANCE: '/finance',
  CRYPTO: '/crypto',
  GEOPOLITICS: '/geopolitics',
  EARNINGS: '/earnings',
  ELECTIONS: '/elections',
  MENTIONS: '/mentions',
  TECH: '/tech',
  CULTURE: '/culture',
  WORLD: '/world',
  ECONOMY: '/economy',
  PORTFOLIO: '/portfolio',
  COMBOS: '/combos',
  ADMIN: {
    DASHBOARD: '/admin',
    USERS: '/admin/users',
    TRADES: '/admin/trades',
    SETTINGS: '/admin/settings',
  },
  LEADERBOARD: '/leaderboard',
  LEADERBOARD_PORTFOLIO: (id: string) => `/leaderboard-portfolio/${id}`,

  BOOKMARKS: '/bookmarks',
  ACTIVITY: '/activity',
  SEARCH: '/search',
  SEARCH_WITH_QUERY: (q: string) => `/search?q=${q}`,
  LOGIN: '/login',
  REGISTER: '/register',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  PROFILE: '/profile',
  VERIFY_EMAIL: '/verify-email',
  TRENDING: '/trending',
  CLIMATE: '/climate',
  SCIENCE: '/science',
  CONTACT_US: '/contact-us',
  DEACTIVATED: '/deactivated',
  REFERRALS: '/referrals',
  STREAKS: '/streaks',
  ERROR_502: '/502',
} as const;

export const MOBILE_NAV_ITEMS = [{ to: ROUTES.PORTFOLIO, label: 'Portfolio' }] as const;

export interface PrimaryFilter {
  label: string;
  path: string;
  isMore?: boolean;
}
